import { Box, Divider, Skeleton } from '@mui/material';
import React from 'react';

const KnowledgeCardSkeleton = () => {
  return (
    <Box>
      <Box py="16px">
        <Skeleton variant="text" width="70%" sx={{ fontSize: 24 }} />
        <Skeleton variant="text" width="200px" height={32} sx={{ fontSize: 12 }} />
        <Skeleton variant="rounded" width="100%" height={60} sx={{ fontSize: 14 }} />
        <Skeleton variant="rounded" width={300} height={24} sx={{ m: '36px 0 -8px auto' }} />
      </Box>
      <Divider />
    </Box>
  );
};

export default KnowledgeCardSkeleton;
